export const API_URL = window._env_.API_URL
export const API_TOKEN = window._env_.API_TOKEN
export const DIGITAL_ID_API_URL = window._env_.DIGITAL_ID_API_URL
export const DIGITAL_ID_CLIENT_ID= window._env_.DIGITAL_ID_CLIENT_ID
export const DIGITAL_ID_REDIRECT_URI = window._env_.DIGITAL_ID_REDIRECT_URI
export const GA_TOKEN = window._env_.GA_TOKEN
export const DEBUG = window._env_.DEBUG
export const TIMEOUT = 10000;
export const VERSION = "0.1.0";
export const VERSION_DATE = "2020-03-21"
export const GET_LAB_TIMEOUT = 1000;
export const VSF_CLIENT_NAME = "Manitoba SH-CORD"
